import React, { ChangeEvent, Component } from "react";
import Popup from "../Popup/Popup";
import { MQBank } from "@eres/mortgageQuotationAPI/entities";
import Strings from "@my-dld/assets/strings";
import { JQModal } from "../Popup/Utils";
import TextInputField from "@eres/forms-web/TextInputField";
import StateHolder from "@eres/forms/StateHolder";
import { LocaleUtil } from "@eres/core";
import _ from "lodash";

interface Props {
	banks: MQBank[];
	selBanks: MQBank[];
	onDismiss: ( banks?: MQBank[] ) => void;
}

interface State {
	selBanks: MQBank[];
	searchKey?: string;
}

class AddBanks extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			selBanks: _.cloneDeep( props.selBanks ),
		};
	}

	render() {
		const { onDismiss } = this.props;
		const { selBanks, searchKey } = this.state;
		const fBanks = this.getFilterData( searchKey );
		const holder = StateHolder.buildStateHolder( this );
		return <Popup
			id={ "AddBanks" }
			autoOpenMount={ true }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
			modalBodyContainer={ "modal-body" }
			title={ Strings.add_bank }
			showIcon={ false }
			onDismiss={ () => {
				JQModal( "AddBanks" ).hide();
				onDismiss();
			} }
			footer={ <button
				className="btn btn_1 btn_style1"
				disabled={ selBanks.length === 0 }
				onClick={ this.onAdd }>{ Strings.add }</button> }>
			<>
				<div className="row">
					<div className={ "col-md-12 mb-1" }>
						<div className="input-group field-with-icon field-style">
							<label className={ "search-wrapper" }>
								<TextInputField
									id={ "searchKey" }
									hideLabel={ true }
									holder={ holder }
									placeHolder={ Strings.search }/>
								<div className="input-group-append">
									<button className="btn btn-input-group" type="button">
										<i className="fa fa-search"/><span className="sr-only">{ Strings.search }</span>
									</button>
								</div>
							</label>
						</div>
					</div>
					<div className="col-md-12 mb-2">
						<small>{ Strings.max_banks_added }</small>
					</div>
				</div>
				<div className="mortgage-bank-detail">
					<div className="list-group">
						{ fBanks.map( ( bank: MQBank ) => {
							const isSelected = selBanks.find( sBank => sBank.id === bank.id ) !== undefined;
							return <div key={ `add_bank_${ bank.id }` } className="form-check">
                                    <input className="form-check-input" checked={ isSelected }
									onChange={ ( event: ChangeEvent<HTMLInputElement> ) => {
										this.onChange( bank, event );
									} }/>
                                        <label className="form-check-label" htmlFor="checkDefault">
                                            { LocaleUtil.getLocalValue( bank ) }
                                        </label>
                                </div>;
						} ) }
					</div>
				</div>
			</>
		</Popup>;
	}

	private getFilterData( sKey?: string ) {
		const { banks } = this.props;
		if ( sKey ) {
			sKey = sKey.toLocaleLowerCase();
			return banks.filter( ( bank: MQBank ) => {
				return LocaleUtil.getLocalValue( bank ).toLocaleLowerCase().includes( sKey! );
			} );
		}
		return banks;
	}

	private onChange( sBank: MQBank, event: ChangeEvent<HTMLInputElement> ) {
		let { selBanks } = this.state;
		if ( event.target.checked ) {
			if ( selBanks.length < 3 ) {
				selBanks.push( sBank );
			}
		} else {
			selBanks = selBanks.filter( bank => sBank.id !== bank.id );
		}
		this.setState( {
			selBanks: selBanks,
		} );
	}

	private onAdd = () => {
		JQModal( "AddBanks" ).hide();
		const banks = this.state.selBanks;
		banks.sort( ( a: MQBank, b: MQBank ) => {
			const aName = LocaleUtil.getLocalValue( a );
			const bName = LocaleUtil.getLocalValue( b );
			return aName.trim().toLowerCase().localeCompare( bName.trim().toLowerCase() );
		} );
		this.props.onDismiss( banks );
	};
}

export default AddBanks;
